import React from 'react';

import { Map as ImmutableMap } from 'immutable';
import { connect } from 'react-redux';
import compose from 'utils/compose';

import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { withStyles } from 'tss-react/mui';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import StdDialog from 'components/Dialogs/StdDialog';
import QButton from 'components/QButton';

import { styles } from './styles';
import { DIALOG_TYPE as DIALOG_NOTIFICATION, mkNotificationDialogProps } from './types';

export const openNotificationDialogAction = (title, content, overrides) =>
  rootUiActions.createDialog(
    rootUiTypes.mkRootUiData({
      id: 'notification-dialog',
      type: DIALOG_NOTIFICATION,
      allowNesting: true,
      props: ImmutableMap(
        mkNotificationDialogProps({
          title,
          content,
        }),
      ),
      ...overrides,
    }),
  );

class NotificationDialog extends React.PureComponent {
  static defaultProps = {
    buttonLabel: 'OK',
  };

  handleClose = () => {
    this.props.removeDialog(this.props.dialogId);
    if (this.props.onClose) {
      this.props.onClose();
    }
    // this.props.closeDialog(event);
  };

  render() {
    const { buttonLabel, content, title, dialogProps, size } = this.props;
    const contentIsString = typeof content === 'string';

    return (
      <StdDialog
        onClose={this.handleClose}
        open
        sharedcomponentid={'DIALOG_NOTIFICATION'}
        showCloseButton={false}
        size={size ? size : 'sm'}
        title={title}
        {...dialogProps}
      >
        <DialogContent>
          {contentIsString ? (
            <DialogContentText id='alert-dialog-description'>{this.props.content}</DialogContentText>
          ) : (
            content
          )}
        </DialogContent>
        {buttonLabel && (
          <DialogActions>
            <QButton id={`notification-${buttonLabel}`} variant='contained' onClick={this.handleClose}>
              {buttonLabel}
            </QButton>
          </DialogActions>
        )}
      </StdDialog>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    removeDialog: (props) => dispatch(rootUiActions.removeDialog(props)),
  };
}

export default compose(connect(null, mapDispatchToProps))(
  withStyles(NotificationDialog, styles, { name: 'AlertDialog' }),
);
